import { css } from '@emotion/react';

export const accordion = css`
  max-height: 55px;
`;

export const sandboxAlert = css`
  margin-top: 16px;
`;
